import { render, staticRenderFns } from "./RoyalHatchery.vue?vue&type=template&id=362c1633&scoped=true&"
import script from "./RoyalHatchery.vue?vue&type=script&lang=js&"
export * from "./RoyalHatchery.vue?vue&type=script&lang=js&"
import style0 from "./RoyalHatchery.vue?vue&type=style&index=0&id=362c1633&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362c1633",
  null
  
)

component.options.__file = "RoyalHatchery.vue"
export default component.exports